<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<!-- 搜索 -->
				<keep-alive>
				<search search_type="product"></search>
				</keep-alive>
				 
				 <!-- 主体列表内容 -->
				 <div class="mainList d-flex">
					 <!-- 安装包 -->
				 	 <div class="proSlide left">
				 		 <div class="prDownload d-flex f-colu a-center j-center bd10">
				 			 <figure><img src="@/assets/Product/proDownloadPic.png" class="w100" alt=""></figure>
				 			 <h3 class="font28 corfff line-sm">{{product.detailName}}</h3>
				 			 <div class="downloadBtn t-center pr" @click="goToPage('/productPackage?productId='+$route.query.productId)">
				 				 <div class="round pr">
				 					 <a href="javascript:;"></a>
				 					 <span></span>
				 				 </div>
				 				 <h4 class="corfff">Downloads</h4>
				 			 </div>
				 		 </div>
				 		 <dl class="bd10">
				 			 <dt>
				 				 <div class="sTitle d-flex a-center j-sb">
				 					 <h3 class="font24"><img src="@/assets/Icons/proZip.png" alt="">{{$t('search.package')}}</h3>
				 					 <a @click="goToPage('/productPackage?productId='+$route.query.productId)" class="link font-light pointer">{{$t('show.more')}} &gt;</a>
				 				 </div>
				 			 </dt>
				 			 <dd>
				 				 <div class="conmonDocument">
				 					 <ul>
				 						 <li class="d-flex j-sb" v-for="(item, index) in versionList" :key="index">
				 							 <h3 class="font18 font-medium file h3"><a class="link" href="javascript:;" @click="goToPage('/productPackageDetail?id='+item.id)">{{item.name}}</a></h3>
				 							 <span class="font14 font-light cor999">{{item.no}}</span>
				 						 </li>
				 					 </ul>
				 				 </div>
				 			 </dd>
				 		 </dl>
				 	 </div>
					 <!-- 文档/常见问题 -->
					 <div class="proSlide middle prDocument">
						 <dl class="bd10">
							 <dt>
								 <div class="sTitle d-flex a-center j-sb">
									 <h3 class="font24"><img src="@/assets/Icons/proDocument.png" alt="">{{$t('product.document')}}</h3>
									 <a @click="goToPage('/productDocument?productId='+$route.query.productId)" class="link font-light pointer">{{$t('show.more')}} &gt;</a>
								 </div>
							 </dt>
							 <dd>
								 <div class="conmonDocument">
									 <ul>
										 <li class="" v-for="(item, index) in documentVOList" :key="index">
											 <div class="d-flex j-sb">
												<h3 class="font18 font-medium pdf h3"><a class="link" target="_blank" :href="item.file">{{item.title}}</a></h3>
											 <p class="d-flex a-center">
												 <span class="font14 font-light cor999">{{item.createTime}}</span>
												 <a @click="downloadFile(item.id,index)"></a>
											 </p>
											 </div>
											 <div class="downbar d-flex j-end" v-show="item.dp>0">
												<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
											</div>
										 </li>
									 </ul>
								 </div>
							 </dd>
						 </dl>
						 <!-- 常见问题 -->
						 <dl class="bd10 pb">
							 <dt>
								 <div class="sTitle d-flex a-center j-sb">
									 <h3 class="font24"><img src="@/assets/Icons/proQuestion.png" alt="">{{$t('product.question')}}</h3>
									 <a @click="goToPage('/productQuestion?productId='+$route.query.productId)" class="link font-light pointer">{{$t('show.more')}} &gt;</a>
								 </div>
							 </dt>
							 <dd>
								 <div class="conmonDocument">
									 <div class="item pointer" @click="goToPage('/questionDetail?id='+item.id)" v-for="(item, index) in FAQVOList" :key="index">
										<h3 class="font18 font-medium que h3 line-sm"><a class="link">{{item.title}}</a></h3>
										<div class="desc cor666 font14 line-md font-light" v-html="item.description" v-if="item.description"></div>
									 </div>
								 </div>
							 </dd>
						 </dl>
					 </div>
					 <!-- 培训视频/相关产品 -->
					 <div class="proSlide right">
						 <dl class="bd10">
							 <dt>
								 <div class="sTitle d-flex a-center j-sb">
									 <h3 class="font24"><img src="@/assets/Icons/proTrain.png" alt="">{{$t('product.train')}}</h3> 
									 <a @click="goToPage('/productTrain?productId='+$route.query.productId)" class="link font-light pointer">{{$t('show.more')}} &gt;</a>
								 </div>
							 </dt>
							 <dd>
								 <div class="trainVOList">
									 <div class="item pointer" @click="goToPage('/onlineTrainDetail?id='+item.id)" v-for="(item, index) in trainVOList" :key="index">
										 <div class="video pr" v-if="index == 0">
											 <figure class="bd10"><img :src="item.cover" class="w100" alt=""></figure>
										 </div>
										 <h3 class="font18 font-medium que h3 line-sm nowrap2"><a class="link">{{item.title}}</a></h3>
										 <span class="font14 font-light cor999">{{$t('product.updateTime')}}：{{item.updateTime}}</span>
									 </div>
								 </div>
							 </dd>
						 </dl>
						 <!-- 相关产品 -->
						 <!-- <dl class="bd10 pb proRelated">
							 <dt>
								 <div class="sTitle d-flex a-center j-sb">
									 <h3 class="font24"><img src="@/assets/Icons/proRelated.png" alt="">{{$t('product.relations')}}</h3>
									 <a @click="goToPage('/product')" class="link font-light pointer">{{$t('show.more')}} &gt;</a>
								 </div>
							 </dt>
							 <dd>
								 <div class="conmonDocument">
									 <ul>
										 <li @click="goToPage('/productDirectory?productId='+item.id)" class="d-flex j-sb pointer" v-for="(item, index) in otherProductList" :key="index">
											 <h3 class="font18 font-medium file h3 nowrap1"><a class="link pointer" target="_blank">{{item.name}}</a></h3>
										 </li>
									 </ul>
								 </div>
							 </dd>
						 </dl> -->
					 </div>
				 </div>
				 
				 <!-- 问题反馈 -->
				 <div class="proFeedback bd10 d-flex j-sb a-center">
					 <div class="pfLeft d-flex a-center ">
						 <figure><img src="@/assets/Product/feedbackPic.png" class="w100" alt=""></figure>
						 <div class="intro">
							 <h3 class="font30 d-flex">{{$t('product.feedback')}}<span class="font18">Problem feedback</span></h3>
							 <p class="font18 line-sm">{{$t('product.feedbackInfo')}}</p>
						 </div>
					 </div>
					 <div class="pfBtn">
						 <a href="javascript:;" @click="goToPage('/feedback')" class="font20 t-sion">{{$t('product.feedbackBtn')}}<span></span></a>
					 </div>
				 </div>
				 
			</div>
		</div>
  </div>
</template>

<script>
// mixins
import mixin from '@/utils/mixins';
// Search组件
import search from './component/search.vue';
// 视频插件
import "@/static/css/video.css"
import '@/static/js/pingzi_video.js'

export default {
  name: 'Product',
  components: {
    search
  },
  data() {
    return {
		// 安装包
		versionList: [],
		// 文档
		documentVOList: [],
		// 常见问题
		FAQVOList: [],
		// 培训视频
		trainVOList: [],
		// 相关产品
		otherProductList: [],
		// 详细信息
		product: {}
	}
  },
  
  // mixins
  mixins: [mixin],
  
  created() {
	  // 获取产品首页
	  this.getProductChildren(this.$route.query.productId);
  },
  
  methods: {
	downloadFile(id,index){
      var that=this;
      if(that.documentVOList[index].dp!=0){return;}
      that.$daxios
        .get(`knowledge/downLog?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.documentVOList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
		if(res.data&&res.data.size==0){
            that.documentVOList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
		  that.documentVOList[index].blob=url;
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
		  that.documentVOList[index].dp=0;
        })
        .catch((err) => {
			that.$message({
              message:"下载失败",
              type: 'error'
            })
          that.documentVOList[index].dp=0;
        });
    },
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  /**
	   * 获取该产品下的类型
	   * @id 产品ID
	   */
	  getProductChildren(id) {
		  this.$axios.post(`product/index`, {productId: id})
		  .then(res => {
			  let data = res.data;
			  // 文档
			  data.documentList.forEach(i=>{i.dp=0;i.blob="";});
			  this.documentVOList = data.documentList;
			  // 培训视频
			  this.trainVOList = data.trainVOList;
			  // 安装包
			  this.versionList = data.versionList;
			  // 常见问题
			  this.FAQVOList = data.FAQVOList;
			  // 相关产品
			  this.otherProductList = data.otherProductList;
			  // 详细信息
			  this.product = data.product;
		  })
		  .catch(err=>{})
	  }
  }
}
</script>

<style lang="less" scoped>
	.mainList{
		margin: 0 -.1rem;
		.proSlide{
			padding: 0 .1rem;
			&.left{
				width: 27.5%;
			}
			&.middle{
				width: 46.25%;
			}
			&.right{
				width: 26.25%;
			}
		}
		.trainVOList{
			.item{
				padding: .18rem 0;
				border-bottom: solid 1px #eee;
				figure{
					background: none;
				}
				.video{
					span img{
						width: .45rem;
					}
				}
				.video{
					margin-bottom: .1rem;
				}
				h3{
					margin-bottom: .1rem;
				}
			}
		}
		.proRelated{
			ul li{
				h3{
					width: 100%;
				}
			}
		}
		.prDocument{
			ul li{
				h3{
					width: 72%;
				}
				p{
					a{
						display: block;
						width: 0.18rem;
						height: 0.18rem;
						background: url(@/assets/Icons/downloadHref.png) no-repeat center/100% 100%;
						margin-left: .4rem;
						&:hover{
							background-image: url(@/assets/Icons/downloadHrefBlue.png);
						}
					}
				}
			}
		}
		.prDownload{
			background: #2e6de1 url(@/assets/Product/proDownloadBg.png) no-repeat right center/cover;
			min-height: 3.5rem;
			figure{
				width: 1rem;
			}
			h3{
				margin: .2rem 0;
				padding: 0 .2rem;
				text-align: center;
			}
			.round{
				a{
					display: block;
					width: .6rem;
					height: .6rem;
					border-radius: 50%;
					background: #2542bb url(@/assets/Product/downloadBtn.png) no-repeat center/.25rem;
					margin: 0 auto .1rem;
					position: relative;
					z-index: 2;
				}
				span{
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%,-50%);
					width: .7rem;
					height: .7rem;
					border-radius: 50%;
					z-index: 1;
					background: #2b60d6;
					
				}
				&:hover span{
					animation:myfirst 1s linear infinite;
					-webkit-animation:myfirst 1s linear infinite; /* Safari and Chrome */
				}
			}
		}
		dl{
			padding: .3rem;
			padding-bottom: 0;
			&.pb{
				padding-bottom: .4rem;
			}
			&:not(:first-child) {
				margin-top: .2rem;
			}
			.sTitle{
				margin-bottom: .1rem;
			}
		}
		@media (max-width: 1200px) {
			flex-direction: column;
			.proSlide{
				padding: 0 .1rem;
				margin-bottom: .3rem;
				&:last-child{
					margin-bottom: 0;
				}
				&.left{
					width: 100%;
				}
				&.middle{
					width: 100%;
				}
				&.right{
					width: 100%;
				}
			}
		}
		@media (max-width: 640px) {
			.prDocument{
				ul li{
					p{
						a{
							margin-left: .1rem;
						}
					}
				}
			}
		}
	}
	@keyframes myfirst
	{
		0%{
			transform: translate(-50%,-50%) scale(1);
		}
		50%{
			transform: translate(-50%,-50%) scale(1.1);
		}
		100%{
			transform: translate(-50%,-50%) scale(1.2);
		}
	}
	
	@-webkit-keyframes myfirst /* Safari and Chrome */
	{
		0%{
			transform: translate(-50%,-50%) scale(1);
		}
		50%{
			transform: translate(-50%,-50%) scale(1.1);
		}
		100%{
			transform: translate(-50%,-50%) scale(1.2);
		}
	}
	.proFeedback{
		margin-top: .2rem;
		background: none;
		height: 1.6rem;
		padding: 0 1.7rem 0 1rem;
		background: url(@/assets/Product/feedbackBg.png) no-repeat right center/cover;
		figure{
			width: .8rem;
			margin-right: .4rem;
		}
		.pfLeft{
			h3{
				margin-bottom: .1rem;
				align-items: baseline;
				span{
					color: #ced6e1;
					margin-left: .2rem;
					text-transform: uppercase;
					font-weight: 400;
				}
			}
		}
		.pfBtn a{
			position: relative;
			display: block;
			width: 1.7rem;
			height: .5rem;
			border-radius: .5rem;
			background: #224ed9;
			color: #fff;
			letter-spacing: 1px;
			text-indent: .2rem;
			line-height: .5rem;
			&:hover{
				box-shadow: 2px 2px 4px rgba(34,78,217,.7);
			}
			span{
				position: absolute;
				right: .1rem;
				top: 50%;
				width: .4rem;
				height: .4rem;
				border-radius: 50%;
				background: #fff url(@/assets/Icons/arrowRightBlue.png) no-repeat center/.2rem;
				transform: translateY(-50%);
			}
		}
		@media (max-width: 1200px) {
			padding: .3rem;
			height: auto;
			display: block;
			.pfBtn{
				margin-top: .3rem;
				text-align: center;
				a{
					display: inline-block;
					text-align: left;
				}
			}
		}
	}
	.conmonDocument{
		.item{
			margin-top: .25rem;
			.desc{
				margin-left: .3rem;
				background: #f4f6f7;
				padding: .2rem;
				margin-top: .15rem;
			}
		}
		ul li{
			padding: .25rem 0;
			span{flex: 0 0 auto;}
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			h3{
				width: 85%;
			}
		}
	}
</style>
